import React from "react";
import QuickLone from "../components/QuickLone/QuickLone";
import Sidebar from "../components/sidebar/Sidebar";

const QuickLonePage = () => {
  return (
    <div>
      <Sidebar />
      <QuickLone />
    </div>
  );
};

export default QuickLonePage;
